import { MultiSelect } from '@dbt-labs/sourdough';
import { DropdownOption } from '@dbt-labs/sourdough';

type ProjectEnvironmentSelectorProps = {
  projectOptions: DropdownOption[];
  environmentOptions: DropdownOption[];
  selectedProjectOption: DropdownOption[];
  selectedEnvironmentOption: DropdownOption[];
  isLoading: boolean;
  isLoadingEnvironments: boolean;
  onProjectChange: (val: readonly DropdownOption[]) => void;
  onEnvironmentChange: (val: readonly DropdownOption[]) => void;
  showEnvironmentSelector?: boolean;
};

export const ProjectEnvironmentSelector = ({
  projectOptions,
  environmentOptions,
  selectedProjectOption,
  selectedEnvironmentOption,
  isLoading,
  isLoadingEnvironments,
  onProjectChange,
  onEnvironmentChange,
  showEnvironmentSelector = true,
}: ProjectEnvironmentSelectorProps) => {
  const selectedProjectId = selectedProjectOption[0]?.value
    ? Number(selectedProjectOption[0].value)
    : undefined;

  return (
    <div className="mt-2">
      <span>
        <MultiSelect
          name="projectId"
          placeholder="Select a project"
          isEdit
          options={projectOptions}
          skeleton={isLoading}
          defaultValue={selectedProjectOption}
          onChange={onProjectChange}
          maxDisplayedSelectedItems={1}
        />
        {showEnvironmentSelector && selectedProjectId && (
          <div className="mt-2">
            <span>
              <MultiSelect
                name="environmentId"
                placeholder="Select an environment"
                isEdit
                options={environmentOptions}
                skeleton={isLoadingEnvironments}
                defaultValue={selectedEnvironmentOption}
                onChange={onEnvironmentChange}
                maxDisplayedSelectedItems={1}
              />
            </span>
          </div>
        )}
      </span>
    </div>
  );
};
